import React, { useState } from 'react';
import Classes from './RecordTable.module.css';
import { useNavigate } from 'react-router-dom';
import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';
import backend from '../../../../../../api';

export default function TableRow({ value, index, sendEmail, getAllInvites }) {
  const navigateTo = useNavigate();
  const [role, setRole] = useState(value.role);

  const handleRoleChange = async (newRole) => {
    if (value.status === 'Active') {
      let backendRole;
      switch (newRole) {
        case 'Admin': backendRole = 'company'; break;
        case 'Employee': backendRole = 'employee'; break;
        case 'Client': backendRole = 'customer'; break;
        default: backendRole = '';
      }
      try {
        await backend.put(`/api/user/${value.userId}`, { role: backendRole });
        setRole(newRole);
        window.location.reload();
      } catch (error) {
        console.error('Error updating role:', error);
      }
    }
  };

  const sales = Number(value?.sales ?? 0);
  const earnings = Number(value?.earnings ?? 0);

  return (
    <>
      {/* ✅ Desktop Row */}
      <div className={`${Classes.customerRow}`} key={value._id} >
        <div className={`${Classes.rowElem} ${Classes.elem1}`} >
          <h5>{value.name || '-'}</h5>
        </div>

        <div className={`${Classes.rowElem} ${Classes.elem2}`}>
          <h5>{value.email}</h5>
        </div>

        <div className={`${Classes.rowElem} ${Classes.elem3}`}>
          <DropDown
            selectedValue={value.role}
            options={["Admin", "Employee"]}
            onChange={handleRoleChange}
            isDropDown={value.status === 'Active'}
            disabled={value.status !== 'Active'}
          />
        </div>

        {/* ✅ Sales */}
        <div className={`${Classes.rowElem} ${Classes.elem4}`}>
          <h5>{sales}</h5>
        </div>

        {/* ✅ Earnings */}
        <div className={`${Classes.rowElem} ${Classes.elem5}`}>
          <h5>${earnings.toFixed(2)}</h5>
        </div>

        {/* ✅ Status */}
        <div className={`${Classes.rowElem} ${Classes.elem6}`}  >
          <DropDown
            selectedValue={value.status}
            options={["Pending Invitation", "Active"]}
            onChange={(val) => value.status = val}
            isDropDown={false}
          />
        </div>

        {/* ✅ Actions */}
        <div className={`${Classes.rowElem} ${Classes.elem7}`}>
          <MoreDropDown
            index={index}
            user={value}
            sendEmail={sendEmail}
            getAllInvites={getAllInvites}
          />
        </div>
      </div>

      {/* ✅ Mobile Card */}
      <div className={Classes.customerRowMobile} >
        <div>
          <div className={Classes.mobElem} >
            <h4>name</h4>
            <h5>{value.name}</h5>
          </div>
          <div className={Classes.mobElem} >
            <h4>email</h4>
            <h5>{value.email}</h5>
          </div>
        </div>

        <div>
          <div className={Classes.mobElem} >
            <h4>role</h4>
            <DropDown
              selectedValue={value.role}
              options={["Admin", "Employee"]}
              onChange={(val) => value.role = val}
              isDropDown={true}
            />
          </div>

          <div className={Classes.mobElem} >
            <h4>sales</h4>
            <h5>{sales}</h5>
          </div>

          <div className={Classes.mobElem} >
            <h4>earnings</h4>
            <h5>${earnings.toFixed(2)}</h5>
          </div>

          <div className={Classes.mobElem} >
            <h4>status</h4>
            <DropDown
              selectedValue={value.status}
              options={["Pending Invitation", "Active"]}
              onChange={(val) => value.status = val}
              isDropDown={false}
            />
          </div>
        </div>

        <MoreDropDown
          index={index}
          user={value}
          sendEmail={sendEmail}
          getAllInvites={getAllInvites}
        />
      </div >
    </>
  );
}
